import React from 'react';
import { I_FRAMES_URL } from '../../utils/Constant';

const IceOpsPage: React.FunctionComponent = () => {
  return (
    <div className="iec-ops-parent">
      <div className="wh-100">
        <iframe
          name="iframe"
          title="iframe"
          width="100%"
          height="100%"
          src={I_FRAMES_URL.ICE_OPS}
        ></iframe>
      </div>
    </div>
  );
};

export default IceOpsPage;
